import React from "react";

const Default = <P extends object>(props: P): JSX.Element => (
    <React.Fragment>
        <h2 className="post-default">Group details unavailable.</h2>
    </React.Fragment>
);

export default Default;
